if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    const sliders = document.querySelectorAll('.ct_slickslider:not(.admin_preview) .slider');

    if (sliders) {
        sliders.forEach((slider) => {
            jQuery(slider).slick({
                arrows: true,
                fade: true,
                prevArrow:
                    '<button class="btn btn-outline-light slick-prev"><i class="fal fa-long-arrow-left"></i></button>',
                nextArrow:
                    '<button class="btn btn-outline-light slick-next"><i class="fal fa-long-arrow-right"></i></button>',
            });
        });
    }
}
